import { render, staticRenderFns } from "./uatclosed.vue?vue&type=template&id=08b307f3&"
import script from "./uatclosed.vue?vue&type=script&lang=js&"
export * from "./uatclosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports